import { Model } from 'es6/components/model'
import { entryScriptName } from 'init/entry-script-name'
import { Defaults } from 'es-decorators'

/**
 * Форма отзыва в карточке товара
 */
@Defaults({
  urlRoot: `${entryScriptName}/api/v3/item-comment`,
  defaults: {
    'is_anonymously': false,
    'reactions': [],
  },
  expand: 'expand=user,reactions,item_comment_photos',
})
export class ItemComment extends Model {}
